@use '@lib/assets/styles/main.scss' as *;

.historyValues {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}

.historyValuesArrow {
  color: $gray500;
}

.historyValuesTitle {
  color: $gray400;
}

.activityBody {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
